<template>
  <div id="overlay" v-if="overlay"></div>
  <!--        <pre>{{ vv._vuelidate_11.content.$model }}</pre>-->
  <form @submit.prevent="handleSubmit" class="p-fluid" autocomplete="off">

    <div class="grid">
      <div class="col-12 lg:col-4 xl:col-4">
        <!--        tbanca-->
        <EditLabel ref="tbanca" :input="banking.tbanca" title="Nombre" :required="true"/>
        <!--        trif_banca-->
        <EditLabel ref="trif_banca" :input="banking.trif_banca" title="RIF" :required="true"/>
        <!--        id_cod_reg_cona-->
<!--        <EditLabel ref="nporcentaje_comision" :input="banking.nporcentaje_comision" title="Porcentaje de Comision" :required="true"/>-->
      </div>
      <div class="col-12 lg:col-4 xl:col-4">
        <EditLabel ref="ncant_prestamos" :input="banking.ncant_prestamos" title="Préstamos" />
      </div>
      <div class="col-12 lg:col-4 xl:col-4">
        <!--        cstatus_banca-->
        <EditDropdown
            ref="cstatus_banca"
            :options="statusList"
            optionLabel="label"
            optionValue="code"
            :selectedInput="banking.cstatus_banca"
            @onChange="onChangeStatus"
            title="Estatus"
        />
        <EditLabel ref="dcreacion" :input="formatDate(banking.dcreacion)" title="Fecha de creaciôn" disabled/>

      </div>
    </div>

    <!--  <Button type="button" @click="vv.$touch()">$touch</button>-->
    <div class="flex justify-content-end">
      <Button
          class="p-button-raised" icon="pi pi-save"
          type="submit"
          :disabled="vv.$errors[0] || !vv.$anyDirty"
      />
    </div>
  </form>

</template>

<script>

import useVuelidate from '@vuelidate/core'
import EditLabel from "@/components/misc/Labels/EditLabel";

import MainService from "@/service/backend/MainService";
import generalMixin from "@/mixins/generalMixin";
import EditDropdown from "@/components/misc/Labels/EditDropdown";
import BankingService from "@/service/backend/BankingService";

export default {
  name: "Tab1",
  components: {EditDropdown, EditLabel},
  mixins: [generalMixin],
  created() {
    this.mainService = new MainService;
    this.bankingService = new BankingService;
  },
  setup() {
    let vv = useVuelidate()
    return {vv};
  },
  props: {
    banking: Object,
  },
  data() {
    return {
      overlay: false,
      statusList: null,
    }
  },
  async mounted() {
    this.statusList = this.getEntityStatus();
    
  },
  methods: {
    onChangeStatus(cstatus_banca) {
      this.selectedStatus = cstatus_banca.value;
    },
    handleSubmit() {
      this.submitted = true;
      const banking = {
        id_banca: this.banking.id,
        tbanca: this.$refs.tbanca.content,
        cstatus_banca: this.$refs.cstatus_banca.content,
        trif_banca: this.$refs.trif_banca.content,
        ncant_prestamos: this.$refs.ncant_prestamos.content,
      };
      this.saveBanking(banking);
    },
    async saveBanking(banking) {
      try {
        this.overlay = banking;
        const response = await this.bankingService.updateBankingDetails(banking);
        if (response.error) {
          this.$toast.add({
            severity: 'error',
            summary: '',
            detail: 'No se pudo editar la banca | ' + response.error,
            life: 10000
          });
          this.overlay = false;
        } else {
          this.$toast.add({severity: 'success', summary: '', detail: `Banca ${banking.tbanca} editado`, life: 3000});
          this.$emit('close', close);
        }

      } catch (e) {
        console.log(e)
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: 'No se pudo editar la banca | ' + e.message,
          life: 10000
        });
      }
      this.overlay = false;
    }
  }

}
</script>
<style>

</style>